// const TRESHOLD = document.querySelector('.topbar.navbar') ? 40 : 44;
import events from 'utils/events';

export default class Sticky {
  constructor() {
    this.body = document.querySelector('.u-body');
    this.header = document.querySelector(`.u-nav-header,[class*='u-nav-header--']`);
    this.placeholder = document.querySelector('.u-nav-header-placeholder');
    this.hasSticky = false;

    if (
      this.body.classList.contains('desktop-hide-header') ||
      document.body.classList.contains('desktop-hide-header')
    ) {
      return false;
    }

    if (!this.header || !this.placeholder) {
      return false;
    }

    if (this.header.classList.contains('u-nav-header--unit')) {
      return false;
    }

    if (this.header.classList.contains('no-sticky')) {
      return false;
    }

    this.hasSticky = true;
    this.treshold = this.getOffset();
    this.y = this.getCurrent();
    this.isSticky = this.y > this.treshold;
    this[this.isSticky ? 'sticky': 'unsticky']();

    this.bind();
  }

  bind() {
    this.update = this.update.bind(this);
    this.updateTreshold = this.updateTreshold.bind(this);
    window.addEventListener('scroll', this.update);
    window.addEventListener('resize', this.updateTreshold);
    window.addEventListener('resize', this.update);
    this.update();
  }

  update() {
    const y = this.getCurrent();

    if (y > this.treshold && !this.isSticky) {
      this.sticky();
    } else if (y < this.treshold && this.isSticky) {
      this.unsticky();
    }
  }

  getCurrent() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  updateTreshold() {
    this.treshold = this.getOffset();
  }

  getOffset() {
    // use placeholder as offset since the pos is always static
    let offset = this.placeholder.offsetTop;

    if (document.querySelector('.topbar.navbar')) {
      offset -= 41;
    }

    return offset;
  }

  sticky() {
    events.emit(events.STICK);
    this.header.classList.add('u-nav-header--sticky');
    this.placeholder.classList.add('active');
    this.isSticky = true;
  }

  unsticky() {
    events.emit(events.UNSTICK);
    this.header.classList.remove('u-nav-header--sticky');
    this.placeholder.classList.remove('active');
    this.isSticky = false;
  }
}
